import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/Login";
import WaiterDashboard from "@/pages/WaiterDashboard";
import WaiterOrderPanel from "@/pages/WaiterOrderPanel";
import KitchenDisplay from "@/pages/KitchenDisplay";
import CashierDashboard from "@/pages/CashierDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import { api } from "@/lib/api";
import { setTableGroups } from "@/lib/tables";
import "@/App.css";

function App() {
    useEffect(() => {
        // Load current table layout once per app boot (any authenticated user
        // can read it; anonymous will just get 401 and we fall back to cache).
        api.get("/config/tables").then((r) => {
            if (r?.data?.groups) setTableGroups(r.data.groups);
        }).catch(() => { /* stay with cached/default */ });
    }, []);
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Navigate to="/login" replace />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route
                            path="/garson"
                            element={
                                <ProtectedRoute roles={["garson", "admin"]}>
                                    <WaiterDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/garson/masa/:tableNumber"
                            element={
                                <ProtectedRoute roles={["garson", "admin"]}>
                                    <WaiterOrderPanel />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/mutfak"
                            element={
                                <ProtectedRoute roles={["mutfak", "admin"]}>
                                    <KitchenDisplay />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/mutfak/masa"
                            element={
                                <ProtectedRoute roles={["mutfak", "admin"]}>
                                    <WaiterDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/mutfak/masa/:tableNumber"
                            element={
                                <ProtectedRoute roles={["mutfak", "admin"]}>
                                    <WaiterOrderPanel />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/kasa"
                            element={
                                <ProtectedRoute roles={["kasa", "admin"]}>
                                    <CashierDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute roles={["admin"]}>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
